import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Shipboard offline support: the service worker keeps the app shell and
// read-only inspection data available with no signal (answers queue in
// IndexedDB and flush on reconnect). Registered after first paint so it
// never competes with initial load.
// Dev bundles aren't content-hashed, so the SW's cache-first /static
// strategy would pin a stale bundle.js — register in production only.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('[sw] registration failed:', err);
    });
  });
} else if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((rs) => rs.forEach((r) => r.unregister()));
}
